export type { RepeatEnd, RepeatRule } from "@shared/taskRepeat";
import type { RepeatEnd, RepeatRule } from "@shared/taskRepeat";

export type RepeatPreset =
  | "never"
  | "minute"
  | "hour"
  | "day"
  | "week"
  | "month"
  | "year";

export function repeatPreset(value: RepeatRule): RepeatPreset {
  if (value.kind === "none") return "never";
  if (value.kind === "interval") return value.unit;
  return value.unit;
}

export function presetRule(preset: RepeatPreset, previous: RepeatRule): RepeatRule {
  const end = previous.kind === "none" ? { kind: "count" as const, count: 1 } : previous.end;
  switch (preset) {
    case "never":
      return { kind: "none" };
    case "minute":
      return { kind: "interval", unit: "minute", every: previous.kind === "interval" && previous.unit === "minute" ? previous.every : 1, end };
    case "hour":
      return { kind: "interval", unit: "hour", every: previous.kind === "interval" && previous.unit === "hour" ? previous.every : 1, end };
    case "day":
      return { kind: "calendar", unit: "day", every: previous.kind === "calendar" && previous.unit === "day" ? previous.every : 1, end };
    case "week":
      return { kind: "calendar", unit: "week", every: previous.kind === "calendar" && previous.unit === "week" ? previous.every : 1, end };
    case "month":
      return { kind: "calendar", unit: "month", every: previous.kind === "calendar" && previous.unit === "month" ? previous.every : 1, end };
    case "year":
      return { kind: "calendar", unit: "year", every: previous.kind === "calendar" && previous.unit === "year" ? previous.every : 1, end };
  }
}

export function repeatSummary(value: RepeatRule): string {
  if (value.kind === "none") return "Never";
  if (value.kind === "interval") return `Every ${value.every} ${value.unit}${value.every === 1 ? "" : "s"}`;
  return `Every ${value.every} ${value.unit}${value.every === 1 ? "" : "s"}`;
}
